import Script from 'next/script';

import { useFeatures } from '@atc/features';

export default function CADAnalyticsScriptLoader() {

    const {
        scripts: [, { cadGA4 }],
    } = useFeatures([
        'scripts',
    ]);

    return cadGA4 && (
        <>
            <Script
                async
                src="https://www.googletagmanager.com/gtag/js?id=G-238572568"
            />
            <Script id="parterTrackingGA4">
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){ dataLayer.push(arguments); }
                    gtag('js', new Date());

                    // Hearst Mags tracking
                    gtag('config', 'G-238572568');

                    // Car and Driver tracking
                    gtag('config', 'G-328809988');
                `}
            </Script>
        </>
    );
}
